module.exports = "/_next/static/images/odontologico-7ff8cae243f69ba44eec22c48fa28d71.svg";